var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8139 9.29285C20.6423 9.29285 21.3139 9.96442 21.3139 10.7928L21.3139 29.2071C21.3139 30.0355 20.6423 30.7071 19.8139 30.7071C18.9855 30.7071 18.3139 30.0355 18.3139 29.2071L18.3139 10.7928C18.3139 9.96442 18.9855 9.29285 19.8139 9.29285Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29291 19.9851C9.29291 19.1567 9.96448 18.4851 10.7929 18.4851L29.2071 18.4851C30.0355 18.4851 30.7071 19.1567 30.7071 19.9851C30.7071 20.8135 30.0355 21.4851 29.2071 21.4851L10.7929 21.4851C9.96448 21.4851 9.29291 20.8135 9.29291 19.9851Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.6b296b21599dfa72f91a9ed60e04eccc.svg";
export { ForwardRef as ReactComponent };